export default __webpack_public_path__ + "static/media/P1 - PG Diploma in bioinformatics.03df4e18.jpg";